import React from 'react'
import PropTypes from 'prop-types'

import { Button } from 'components'

import cx from 'helpers/cx'

import classes from './ProductCard.module.scss'

const ViewDetailsLink = ({ href, className, style, children = 'View details' }) => {
  if (!href) {
    return null
  }

  return (
    <Button
      variant="textLink"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className={cx(classes.viewDetailsLink, className)}
      style={style}
    >
      {children}
    </Button>
  )
}

ViewDetailsLink.displayName = 'ViewDetailsLink'
ViewDetailsLink.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object,
  children: PropTypes.node,
}

export default ViewDetailsLink
